import { useMemo } from 'react';
import { resolveAvailablePlatforms } from '@/features/interactions/addToCalendar/destinations/registry';
import { useDestinationAvailability } from '@/features/interactions/addToCalendar/destinations/useDestinationAvailability';
import type { PlatformTypes } from '@/types/gql.generated';

/**
 * Which of `candidates` this workspace actually offers, in display order —
 * the flag funnel every destination picker must share or the surfaces
 * disagree about what exists: unavailable destinations (Agenda Hero without
 * its flags, the Outlook integration without its flag) drop out, and an
 * available integration stands in for the weblinks it supersedes.
 *
 * Pass a module-level constant as `candidates` — the result is memoized on it.
 */
export const useExportPlatforms = (
  candidates: PlatformTypes[]
): PlatformTypes[] => {
  const availability = useDestinationAvailability();

  return useMemo(
    () => resolveAvailablePlatforms(candidates, availability),
    [candidates, availability]
  );
};
